import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PeriodSelectorProps {
  year: number;
  month: number;
  onChange: (year: number, month: number) => void;
}

const MONTH_NAMES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({ year, month, onChange }) => {
  const goPrev = () => {
    if (month === 1) {
      onChange(year - 1, 12);
    } else {
      onChange(year, month - 1);
    }
  };

  const goNext = () => {
    if (month === 12) {
      onChange(year + 1, 1);
    } else {
      onChange(year, month + 1);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={goPrev}
        className="p-1.5 rounded-md hover:bg-gray-100 transition-colors text-gray-600"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span className="text-sm font-medium text-gray-700 min-w-[140px] text-center">
        {MONTH_NAMES[month - 1]} {year}
      </span>
      <button
        onClick={goNext}
        className="p-1.5 rounded-md hover:bg-gray-100 transition-colors text-gray-600"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};
